// extracted by mini-css-extract-plugin
export default {"container":"VNhBJci","menuItem":"ieh7uOA jFyrDfG w3QwoQC","label":"XRueqw2","label__sale":"yvQJWQx","image":"VcUfeVh"};